module.exports = __webpack_public_path__ + "img/80a02dd.jpg";